var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * Google Maps Api JS
 * https://developers.google.com/maps/documentation/javascript/geocoding
 */
var GeoCodeService = function () {
    function GeoCodeService($http, $log, $q) {
        _classCallCheck(this, GeoCodeService);

        this.$http = $http;
        this.$log = $log;
        this.$q = $q;

        if (window.google && window.google.maps) {
            // throw new Error('google map api not found');
            this.mapsApi = window.google.maps;
            this.geocoder = new this.mapsApi.Geocoder();
        } else {
            $log.warn('google map api not found');
        }
    }

    /*
     * Geocode Address model to cords latitude, longitude
     */


    _createClass(GeoCodeService, [{
        key: 'geocodeAddress',
        value: function geocodeAddress(address) {
            var _this = this;

            var defer = this.$q.defer();

            if (!this.mapsApi) {
                throw new Error('google map api not found');
            }

            var search = address.addressLine1;
            if (address.addressLine2) {
                search = address.addressLine1 + ' ' + address.addressLine2;
            }
            search = search + ', ' + address.city + ', ' + address.state;

            this.geocoder.geocode({
                address: search,
                componentRestrictions: {
                    country: address.country,
                    postalCode: address.postalCode
                }
            }, function (results, status) {
                if (status === _this.mapsApi.GeocoderStatus.OK && results.length > 0) {
                    defer.resolve({
                        latitude: results[0].geometry.location.lat(),
                        longitude: results[0].geometry.location.lng()
                    });
                } else {
                    console.warn('Google Geocode API error : ' + status);
                    defer.reject();
                }
            });

            return defer.promise;
        }

        /*
         * Geocode GooglePlace object to cords latitude, longitude
         */

    }, {
        key: 'geocodePlace',
        value: function geocodePlace(placeId) {
            var _this2 = this;

            var defer = this.$q.defer();

            if (!this.mapsApi) {
                throw new Error('google map api not found');
            }

            this.geocoder.geocode({ placeId: placeId }, function (results, status) {
                if (status === _this2.mapsApi.GeocoderStatus.OK && results.length > 0) {
                    defer.resolve({
                        latitude: results[0].geometry.location.lat(),
                        longitude: results[0].geometry.location.lng()
                    });
                } else {
                    console.warn('Google Geocode API error : ' + status);
                    defer.reject();
                }
            });

            return defer.promise;
        }

        /*
         * Legacy Google Geocode Rest Api
         */

    }, {
        key: 'getGeoCodedAddr',
        value: function getGeoCodedAddr(lat, lon) {
            var _this3 = this;

            var sensor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            var geoCodeURL = 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + ',' + lon + '&sensor=' + sensor;
            return this.$http({
                method: 'GET',
                url: geoCodeURL,
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                var address = {
                    addressLine1: '',
                    addressLine2: '',
                    city: '',
                    state: '',
                    postalCode: '',
                    country: '',
                    countryCode: ''
                };
                if (response.data.status === 'OK') {
                    var addressComponents = response.data.results[0].address_components;
                    var streetNumber = void 0;
                    var streetName = void 0;
                    for (var i = 0; i < addressComponents.length; i++) {
                        var addr = addressComponents[i];

                        var types = addr.types.join();
                        switch (types) {
                            case 'country':
                                address.country = addr.short_name;
                                break;
                            case 'street_number':
                                streetNumber = addr.long_name;
                                break;
                            case 'route':
                                streetName = addr.long_name;
                                break;
                            case 'postal_code':
                                address.postalCode = addr.short_name;
                                break;
                            case 'country,political':
                                address.country = addr.long_name;
                                address.countryCode = addr.short_name;
                                break;
                            case 'administrative_area_level_1,political':
                                address.state = addr.short_name;
                                break;
                            case 'locality,political':
                                address.city = addr.long_name;
                                break;
                            default:
                        }
                    }

                    if (streetNumber && streetName) {
                        address.addressLine1 = streetNumber + ' ' + streetName;
                    } else if (streetName) {
                        address.addressLine1 = streetName;
                    } else if (streetNumber) {
                        address.addressLine1 = streetName;
                    }
                }
                return address;
            }, function (error, status, headers) {
                return _this3.$q.reject([error, status, headers]);
            });
        }
    }]);

    return GeoCodeService;
}();

GeoCodeService.$inject = ['$http', '$log', '$q'];

export default GeoCodeService;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/map/GeoCodeService.js
// module id = 1047
// module chunks = 0